import { useContext } from 'react';
import { ProviderContext } from '../context/ProviderContext';

export function useProvider() {
  const context = useContext(ProviderContext);
  if (context === undefined) {
    throw new Error('useProvider must be used within a ProviderProvider');
  }
  return context;
}
